import { useState } from '@wordpress/element';
import { CardItensSugestoes } from './CardItensSugestoes';
import { OptiTabs } from '@componentsNew/OptiTabs';

export function TabsAnaliseArtigo() {
  const [selecionado, setSelecionado] = useState('palavras');
  const data = [
    {
      label: 'Palavras',
      value: 'palavras',
      content: <CardItensSugestoes />,
    },
    {
      label: 'Link building',
      value: 'link-building',
      content: <CardItensSugestoes />,
    },
  ];

  return (
    <OptiTabs
      className="rounded-none p-0 border-b-[2px] border-solid border-text-secundary border-x-0 border-t-0 w-auto"
      indicatorProps='border-b-[3px] border-x-0 border-t-0 rounded-none border-solid border-sucess-main shadow-none top-[-1px]'
      selecionado={selecionado}
      setSelecionado={setSelecionado}
      data={data}
    />
  );
}
